<template>
  <div ref="chartContainer" style="width: 100%; height: 400px;"></div>
</template>

<script setup lang="ts">
import { ref, onMounted, watch, onUnmounted } from 'vue';
import * as echarts from 'echarts';
import type { EChartsOption } from 'echarts';

const props = defineProps<{
  chartData: {
    labels: string[];
    datasets: Array<{
      label: string;
      data: number[];
      backgroundColor?: string;
      borderColor?: string;
    }>;
  };
  chartType?: 'line' | 'bar';
}>();

const chartContainer = ref<HTMLElement | null>(null);
let chartInstance: echarts.ECharts | null = null;

const updateChart = () => {
  if (!chartInstance) return;

  const option: EChartsOption = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    xAxis: {
      type: 'category',
      data: props.chartData.labels,
      axisLabel: {
        rotate: 45
      }
    },
    yAxis: {
      type: 'value'
    },
    series: props.chartData.datasets.map(dataset => ({
      name: dataset.label,
      type: props.chartType || 'bar',
      data: dataset.data,
      itemStyle: {
        color: dataset.backgroundColor || '#166b43'
      }
    }))
  };

  chartInstance.setOption(option);
};

onMounted(() => {
  if (chartContainer.value) {
    chartInstance = echarts.init(chartContainer.value);
    updateChart();
  }
});

watch(() => props.chartData, () => {
  updateChart();
}, { deep: true });

// Handle window resize
const handleResize = () => {
  chartInstance?.resize();
};

window.addEventListener('resize', handleResize);

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
  chartInstance?.dispose();
});
</script>

<style scoped>
/* Add any styles if necessary */
</style> 